import { Form, Formik } from "formik";
//import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import Modal from "shared/Modal";
import InputField from "shared/Formik/InputField";
import Button from "shared/Button";
import { updateProfile } from "app/account/actions";

import moment from "moment";

export default function UpdateBirthdayModal({ birthday, onClose, open }) {
  const dispatch = useDispatch();
  // const [error, setError] = useState(null);

  // useEffect(() => {
  //   setError(null);
  // }, [open]);

  return (
    <Modal isOpen={open} handleClose={onClose} title="Set your birthday">
      <Formik
        initialValues={{
          birthday: birthday
        }}
        onSubmit={async ({ birthday }) => {
          await dispatch(
            updateProfile({
              birthday: moment(birthday, "DD/MM/YYYY").format("YYYY-MM-DD")
            })
          );

          onClose();
        }}
        validationSchema={Yup.object().shape({
          birthday: Yup.string().matches(
            /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/\d{4}$/,
            "Please enter a birthday in the format DD/MM/YYYY"
          )
        })}
      >
        {({ isSubmitting }) => (
          <Form className="mt-3">
            <InputField
              name="birthday"
              type="text"
              label="Birthday"
              placeholder="DD/MM/YYYY"
            />
            <div className="mt-4">
              <Button
                type="submit"
                size="md"
                className="me-3"
                isLoading={isSubmitting}
              >
                Update
              </Button>
              <Button
                size="md"
                btnType="tertiary"
                onClick={onClose}
                type="reset"
              >
                Cancel
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
